import React, { useState, useEffect } from 'react';
import styles from './evaluationTemplates.module.scss';
import {
    Route,
    Routes,
    Navigate,
    NavLink
} from 'react-router-dom';
import QuizTemplates from './quizTemplates';
import CustomNavbar from '../customNavbar';
import { useNavigate } from "react-router-dom";
import OneWayInterviewTemplates from './oneWayInterviewTemplates';

const EvaluationTemplates = (props) => {
    let [isURLLoading, setURLLoading] = useState(false);
    const breadcrumb = [
        {
            pathaddress: '/app/company/templates/',
            pathname: 'Templates',
            isActive: false,
            key: 1 + 'templates'
        }
    ];

    const breacrumbText = 'From here you can create templates for quizes and One-way interviews. Basically, a template is a predefined question set for the candidates.'

    let history = useNavigate();

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView
    }

    return (
        <div>
            <div className={styles.settingsBodyContainer}>
                <div className={styles.backgroundFixedComponents}>
                    <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb}  breacrumbText= {breacrumbText}/>
                </div>
                <div className={styles.companySettingsBodyWrapper}>
                    <ul className={styles.tabOptionsContainer}>
                        <NavLink to="/company/templates/quiz-templates" id="evaluation_templates_quiz_templates_nav" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer }>
                            <li className={styles.switchActive}> <p className={styles.settingsContentSwitch}>Quiz Templates</p></li>
                        </NavLink>
                        <NavLink to="/company/templates/one-way-interview-templates" id="evaluation_templates_one_way_interview_templates_nav" className={({ isActive }) => isActive ? styles.subCategoryContainerActive : styles.subCategoryContainer }>
                        <li className={styles.switchActive}><p className={styles.settingsContentSwitch}>One Way Interview Templates</p></li>
                    </NavLink>
                    </ul>
                    <Routes>
                        <Route path='quiz-templates' element={<QuizTemplates main_props={main_props}  {...props} />} />
                        <Route path='one-way-interview-templates' element={<OneWayInterviewTemplates main_props={main_props} {...props} />} />
                        <Route index element={<Navigate replace to="quiz-templates" />} />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default EvaluationTemplates;